import { render, staticRenderFns } from "./checkbox-box-box.vue?vue&type=template&id=d0956230&scoped=true"
import script from "./checkbox-box-box.vue?vue&type=script&lang=js"
export * from "./checkbox-box-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0956230",
  null
  
)

export default component.exports